module.exports = __webpack_public_path__ + "static/media/project.65f15ca8.pbxproj";